<template>
	<div class="containers">
		<div class="table-box">
			<div class="table-header">
				<h3 class="table-title">مدیریت منو</h3>
				<Button 
					btnType="primary" 
					title="افزودن منو جدید" 
					@click="openCreateModal"
					class="add-btn"
				>
				</Button>
			</div>
			
			<pagination v-model="page" :per-page="20" :records="totalDataCount" @paginate="myCallback" />
			<Tableview
				class="table pb-4"
				:hover="true"
				:bordered="true"
				:showNoContent="showContnetFunc"
				:showNoData="showDataFunc"
			>
				<template #TableTitle>
					<tr>
						<th>شماره</th>
						<th>نام</th>
						<th>نام نمایشی</th>
						<th>اولویت</th>
						<th>وضعیت</th>
						<th>آیکون فعال</th>
						<th>آیکون غیرفعال</th>
						<th>مسیر فرانت</th>
						<th>پارامترهای API</th>
						<th>آیا iframe دارد</th>
						<th>لینک iframe</th>
						<th>زیرمنوها</th>
						<th>عملیات</th>
					</tr>
				</template>

				<template #TableBody>
					<tr v-for="(item, index) in menuList" :key="item.id" class="menu-detail">
						<td class="persian-number">{{ 1 + index }}</td>
						<td>{{ item.name }}</td>
						<td>{{ item.verbose_name }}</td>
						<td class="persian-number">{{ item.priority }}</td>
						<td>
							<span v-if="item.is_active" class="status-badge success">فعال</span>
							<span v-else class="status-badge danger">غیرفعال</span>
						</td>
                        <td>
							<img v-if="item.deactive_icon" :src="item.active_icon" class="icon-preview" alt="آیکون">
							<span v-else class="text-muted">-</span>
						</td>
						<td>
							<img v-if="item.deactive_icon" :src="item.deactive_icon" class="icon-preview" alt="آیکون">
							<span v-else class="text-muted">-</span>
						</td>
						<td>
							<span v-if="item.frontend_route_url" class="route-url">{{ item.frontend_route_url }}</span>
							<span v-else class="text-muted">-</span>
						</td>
						<td>
							<span v-if="item.frontend_api_queryparams" class="api-params">{{ item.frontend_api_queryparams }}</span>
							<span v-else class="text-muted">-</span>
						</td>
						<td>
							<span v-if="item.has_iframe" class="status-badge success">بله</span>
							<span v-else class="status-badge danger">خیر</span>
						</td>
						<td>
							<span v-if="item.iframe_link" class="iframe-link">{{ item.iframe_link }}</span>
							<span v-else class="text-muted">-</span>
						</td>
						<td>
							<span v-if="item.children && item.children.length > 0" class="children-count">
								{{ item.children.length }} زیرمنو
							</span>
							<span v-else class="text-muted">-</span>
						</td>
						<td>
							<div class="action-buttons">
								<Button 
									btnType="primary" 
									btnSize="sm" 
									title="ویرایش" 
									@click="openEditModal(item)"
									class="edit-btn"
								>
								</Button>
							</div>
						</td>
					</tr>
				</template>
			</Tableview>
		</div>

		<!-- Edit Modal -->
		<Modal ref="editModal" size="large" :closeBtn="true">
			<template #mnx-header>
				<h4>ویرایش منو</h4>
			</template>
			<template #mnx-body>
				<form @submit.prevent="updateMenu" class="menu-form">
					<div class="form-row">
						<div class="form-group">
							<label>نام:</label>
							<input type="text" v-model="editForm.name" class="form-control" required>
						</div>
						<div class="form-group">
							<label>نام نمایشی:</label>
							<input type="text" v-model="editForm.verbose_name" class="form-control" required>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group">
							<label>اولویت:</label>
							<input type="number" v-model="editForm.priority" class="form-control" required>
						</div>
						<div class="form-group">
							<label>وضعیت:</label>
							<select v-model="editForm.is_active" class="form-control">
								<option :value="true">فعال</option>
								<option :value="false">غیرفعال</option>
							</select>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group">
							<label>آیکون غیرفعال:</label>
							<input type="url" v-model="editForm.deactive_icon" class="form-control">
						</div>
						<div class="form-group">
							<label>مسیر فرانت:</label>
							<input type="text" v-model="editForm.frontend_route_url" class="form-control">
						</div>
					</div>
					<div class="form-row">
						<div class="form-group">
							<label>پارامترهای API:</label>
							<input type="text" v-model="editForm.frontend_api_queryparams" class="form-control">
						</div>
						<div class="form-group">
							<label>آیا iframe دارد:</label>
							<select v-model="editForm.has_iframe" class="form-control">
								<option :value="false">خیر</option>
								<option :value="true">بله</option>
							</select>
						</div>
					</div>
					<div class="form-row" v-if="editForm.has_iframe">
						<div class="form-group full-width">
							<label>لینک iframe:</label>
							<input type="url" v-model="editForm.iframe_link" class="form-control">
						</div>
					</div>
				</form>
			</template>
			<template #mnx-footer>
				<div class="modal-actions">
					<button class="btn__secondary" @click="closeEditModal">انصراف</button>
					<button class="btn__primary" @click="closeEditModal" :loading="updateLoading">ذخیره و بستن</button>
				</div>
			</template>
		</Modal>

		<!-- Create Modal -->
		<Modal ref="createModal" size="large" :closeBtn="true">
			<template #mnx-header>
				<h4>افزودن منو جدید</h4>
			</template>
			<template #mnx-body>
				<form @submit.prevent="createMenu" class="menu-form">
					<div class="form-row">
						<div class="form-group">
							<label>نام:</label>
							<input type="text" v-model="createForm.name" class="form-control" required>
						</div>
						<div class="form-group">
							<label>نام نمایشی:</label>
							<input type="text" v-model="createForm.verbose_name" class="form-control" required>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group">
							<label>اولویت:</label>
							<input type="number" v-model="createForm.priority" class="form-control" required>
						</div>
						<div class="form-group">
							<label>وضعیت:</label>
							<select v-model="createForm.is_active" class="form-control">
								<option :value="true">فعال</option>
								<option :value="false">غیرفعال</option>
							</select>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group">
							<label>آیکون غیرفعال:</label>
							<input type="url" v-model="createForm.deactive_icon" class="form-control">
						</div>
						<div class="form-group">
							<label>مسیر فرانت:</label>
							<input type="text" v-model="createForm.frontend_route_url" class="form-control">
						</div>
					</div>
					<div class="form-row">
						<div class="form-group">
							<label>پارامترهای API:</label>
							<input type="text" v-model="createForm.frontend_api_queryparams" class="form-control">
						</div>
						<div class="form-group">
							<label>آیا iframe دارد:</label>
							<select v-model="createForm.has_iframe" class="form-control">
								<option :value="false">خیر</option>
								<option :value="true">بله</option>
							</select>
						</div>
					</div>
					<div class="form-row" v-if="createForm.has_iframe">
						<div class="form-group full-width">
							<label>لینک iframe:</label>
							<input type="url" v-model="createForm.iframe_link" class="form-control">
						</div>
					</div>
				</form>
			</template>
			<template #mnx-footer>
				<div class="modal-actions">
					<button class="btn__secondary" @click="closeCreateModal">انصراف</button>
					<button class="btn__primary" @click="closeCreateModal" :loading="createLoading">ذخیره و بستن</button>
				</div>
			</template>
		</Modal>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from '@/components/ListPagination/index.vue';
import Modal from '../../components/Modal/Modal.vue';
import Button from '../../components/Button/Button.vue';

export default {
	components: {
		Tableview,
		Pagination,
		Modal,
		Button,
	},
	data() {
		return {
			page: 1,
			totalDataCount: 0,
			menuList: [],
			updateLoading: false,
			createLoading: false,
			editForm: {
				id: null,
				name: '',
				verbose_name: '',
				priority: 1,
				is_active: true,
				deactive_icon: '',
				frontend_route_url: '',
				frontend_api_queryparams: '',
				has_iframe: false,
				iframe_link: '',
			},
			createForm: {
				name: '',
				verbose_name: '',
				priority: 1,
				is_active: true,
				deactive_icon: '',
				frontend_route_url: '',
				frontend_api_queryparams: '',
				has_iframe: false,
				iframe_link: '',
			},
		};
	},
	computed: {
		showContnetFunc() {
			return this.menuList.length === 0;
		},
		showDataFunc() {
			if (this.menuList.length !== undefined) {
				return this.menuList.length === 0;
			}
			return false;
		},
	},
	mounted() {
		this.getMenuList();
	},
	methods: {
		async getMenuList() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.MENU_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&is_active=true',
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.menuList = res.data;
				this.totalDataCount = res.data.length;
			}
		},
		async myCallback() {
			// For menu list, we don't need pagination as it's a simple list
			await this.getMenuList();
		},
		openEditModal(item) {
			this.editForm = {
				id: item.id,
				name: item.name || '',
				verbose_name: item.verbose_name || '',
				priority: item.priority || 1,
				is_active: item.is_active !== undefined ? item.is_active : true,
				deactive_icon: item.deactive_icon || '',
				frontend_route_url: item.frontend_route_url || '',
				frontend_api_queryparams: item.frontend_api_queryparams || '',
				has_iframe: item.has_iframe !== undefined ? item.has_iframe : false,
				iframe_link: item.iframe_link || '',
			};
			this.$refs.editModal.open();
		},
		closeEditModal() {
			this.$refs.editModal.close();
			this.resetEditForm();
		},
		openCreateModal() {
			this.resetCreateForm();
			this.$refs.createModal.open();
		},
		closeCreateModal() {
			this.$refs.createModal.close();
			this.resetCreateForm();
		},
		resetEditForm() {
			this.editForm = {
				id: null,
				name: '',
				verbose_name: '',
				priority: 1,
				is_active: true,
				deactive_icon: '',
				frontend_route_url: '',
				frontend_api_queryparams: '',
				has_iframe: false,
				iframe_link: '',
			};
		},
		resetCreateForm() {
			this.createForm = {
				name: '',
				verbose_name: '',
				priority: 1,
				is_active: true,
				deactive_icon: '',
				frontend_route_url: '',
				frontend_api_queryparams: '',
				has_iframe: false,
				iframe_link: '',
			};
		},
		async updateMenu() {
			this.updateLoading = true;
			try {
				const res = await this.$ApiServiceLayer.put(
					this.$PATH.RELATIVE_PATH.PUT.MENU_UPDATE + this.editForm.id + '/',
					this.editForm,
					this.$PATH.SERVICE_NAME.AUTH,
				);
				if (res.status === 200) {
					this.$notify({
						group: 'success',
						title: 'موفق',
						text: 'منو با موفقیت ویرایش شد',
					});
					this.closeEditModal();
					await this.getMenuList();
				}
			} catch (error) {
				this.$notify({
					group: 'error',
					title: 'خطا',
					text: 'خطا در ویرایش منو',
				});
			} finally {
				this.updateLoading = false;
			}
		},
		async createMenu() {
			this.createLoading = true;
			try {
				const res = await this.$ApiServiceLayer.post(
					this.$PATH.RELATIVE_PATH.POST.MENU_CREATE,
					this.createForm,
					this.$PATH.SERVICE_NAME.AUTH,
				);
				if (res.status === 201) {
					this.$notify({
						group: 'success',
						title: 'موفق',
						text: 'منو با موفقیت ایجاد شد',
					});
					this.closeCreateModal();
					await this.getMenuList();
				}
			} catch (error) {
				this.$notify({
					group: 'error',
					title: 'خطا',
					text: 'خطا در ایجاد منو',
				});
			} finally {
				this.createLoading = false;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.containers {
	padding: 24px;
	
	.table-box {
		background: var(--surface);
		border-radius: 12px;
		padding: 24px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.table-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 24px;
		padding-bottom: 16px;
		border-bottom: 2px solid var(--surface-sunken);

		.table-title {
			font-size: 24px;
			font-weight: 600;
			color: var(--text);
			margin: 0;
		}

		.add-btn {
			background: var(--action);
			border: none;
			border-radius: 8px;
			padding: 12px 24px;
			font-weight: 500;
			transition: all 0.3s ease;
            color: var(--surface);
			&:hover {
				transform: translateY(-2px);
				box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
			}
		}
	}

	.menu-detail {
		transition: all 0.3s ease;

		&:hover {
			background-color: var(--surface-sunken);
			transform: translateY(-1px);
		}
	}

	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}

	.status-badge {
		padding: 6px 12px;
		border-radius: 20px;
		font-size: 12px;
		font-weight: 600;
		text-transform: uppercase;
		letter-spacing: 0.5px;

		&.success {
			background: var(--teal-700);
			color: var(--surface);
		}

		&.danger {
			background: linear-gradient(135deg, var(--pink-500) 0%, var(--pink-700) 100%);
			color: var(--surface);
		}
	}

	.text-muted {
		color: var(--text-3);
		font-style: italic;
	}

	.icon-preview {
		width: 34px;
		height: 34px;
		border-radius: 4px;
		object-fit: cover;
        background: var(--text-3);
        padding: 4px;
        border-radius: 4px;
	}

	.route-url, .api-params, .iframe-link {
		font-family: 'Courier New', monospace;
		font-size: 11px;
		background-color: var(--surface-sunken);
		padding: 2px 6px;
		border-radius: 4px;
		max-width: 150px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}

	.children-count {
		background: var(--action);
		color: white;
		padding: 4px 8px;
		border-radius: 12px;
		font-size: 11px;
		font-weight: 500;
	}

	.action-buttons {
		display: flex;
		gap: 8px;
		justify-content: center;

		.edit-btn {
			background: var(--surface);
			border: 1px solid var(--text-3) !important;
			border-radius: 8px;
			padding: 6px 12px;
			font-size: 12px;
			font-weight: 500;
			transition: all 0.3s ease;

			&:hover {
				transform: translateY(-1px);
				box-shadow: 0 4px 8px rgba(79, 172, 254, 0.3);
			}
		}
	}

	// Modal styles
	.menu-form {
		.form-row {
			display: flex;
			gap: 16px;
			margin-bottom: 20px;

			.form-group {
				flex: 1;
				display: flex;
				flex-direction: column;

				&.full-width {
					flex: 100%;
				}

				label {
					font-weight: 600;
					margin-bottom: 8px;
					color: var(--text);
					font-size: 14px;
				}

				.form-control {
					padding: 12px 16px;
					border: 2px solid var(--line);
					border-radius: 8px;
					font-size: 14px;
					transition: all 0.3s ease;

					&:focus {
						outline: none;
						border-color: var(--teal-700);
						box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
					}
				}

				select.form-control {
					cursor: pointer;
				}
			}
		}
	}

	.modal-actions {
		display: flex;
		gap: 12px;
		justify-content: flex-end;
		margin-top: 20px;
	}
}
</style>
<style>
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input:disabled {
	background: var(--surface);
	text-align: center;
	min-width: 130px;
	border: none;
	font-family: 'IRANYekanfa' !important;
	font-size: 16px;
}
.VuePagination__count {
	display: none;
}
.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}
.btn__secondary {
	background: var(--text-3);
	color: var(--surface);
	border-radius: 8px;
	padding: 10px 20px;
    border: none;
}
.btn__primary {
	background: var(--action);
	color: var(--surface);
	border-radius: 8px;
    border: none;
	padding: 10px 20px;
}
</style>
